module.exports = __webpack_public_path__ + "assets/img/icon_check.svg";